import { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'

export const RequireAuth = ({ children }: { children: ReactNode }) => {
  const { user, loading } = useAuth()
  const location = useLocation()

  if (loading) {
    return <div className="p-4 text-center">Carregando…</div>
  }

  if (!user) {
    return <Navigate to="/pwa/auth" replace state={{ from: location.pathname }} />
  }

  return <>{children}</>
}